import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    ...shorthands.padding(0, '16px'),
  },

  baseSaveButton: {
    minWidth: '110px',
  },
});
